import { FilterValues } from "../../../data-model/filterValues";
import { convertDateToMMDDYYYYFormat } from "./convertDateToApiFormat";
import { PrimaryCareFilterKeys } from "./createFilterSections";

// Map filter keys to API field names
const FILTER_KEY_MAPPING: Record<string, string> = {
  [PrimaryCareFilterKeys.SECOND_STP_STATUS]: "second_stp_status",
  [PrimaryCareFilterKeys.RESPONSE_STATUS]: "response_status",
  [PrimaryCareFilterKeys.CASE_STATUS]: "case_status",
  [PrimaryCareFilterKeys.POC]: "poc",
  [PrimaryCareFilterKeys.DATE_OF_SERVICE]: "date_range",
  [PrimaryCareFilterKeys.ROUTE_VIA]: "route_via",
  [PrimaryCareFilterKeys.AUTH_TYPE]: "specialty",
  [PrimaryCareFilterKeys.KEY_SOURCE]: "key_source",
};

export const processFilterData = (validFilters: FilterValues[]) => {
  if (!validFilters?.[0]?.["filterCount"]) return {};

  const allFilters = validFilters[0];
  const filters = Object.keys(allFilters).filter((key) => key === "values");
  const filterValues = filters.map((filter) => allFilters[filter]);

  const processedFilters = Object.keys(filterValues?.[0] || {})
    .map((key) => {
      const apiKey = FILTER_KEY_MAPPING[key] || key;
      return {
        [apiKey]: filterValues?.[0]?.[key]?.values,
      };
    })
    .reduce((acc, curr) => ({ ...acc, ...curr }), {});

  // Special handling for date_of_filing filter - convert to date range format with MM/DD/YYYY
  if (processedFilters["date_range"]) {
    const dateValues = processedFilters["date_range"];
    if (dateValues && dateValues.length > 0) {
      const startDate = convertDateToMMDDYYYYFormat(dateValues[0]);
      const endDate =
        dateValues.length >= 2
          ? convertDateToMMDDYYYYFormat(dateValues[1])
          : startDate;

      processedFilters["date_range"] = {
        start_date: startDate,
        end_date: endDate,
      };
    }
  }

  return processedFilters;
};
